// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 *
 * @export
 * @interface ProjectCreate
 */
export interface ProjectCreate {
  /**
   *
   */
  code: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  location?: Point | null;
  /**
   *
   */
  locationName?: string | null;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  clientName?: string | null;
  /**
   *
   */
  applyFolderTemplate?: boolean;
}

/**
 * Check if a given object implements the ProjectCreate interface.
 */
export function instanceOfProjectCreate(value: object): value is ProjectCreate {
  if (!("code" in value) || value["code"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function ProjectCreateFromJSON(json: any): ProjectCreate {
  return ProjectCreateFromJSONTyped(json, false);
}

export function ProjectCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCreate {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    name: json["name"],
    location:
      json["location"] === undefined
        ? undefined
        : json["location"] === null
        ? null
        : PointFromJSON(json["location"]),
    locationName:
      json["location_name"] === undefined
        ? undefined
        : json["location_name"] === null
        ? null
        : json["location_name"],
    description: json["description"] == null ? undefined : json["description"],
    clientName:
      json["client_name"] === undefined
        ? undefined
        : json["client_name"] === null
        ? null
        : json["client_name"],
    applyFolderTemplate:
      json["apply_folder_template"] == null ? undefined : json["apply_folder_template"],
  };
}

export function ProjectCreateToJSON(json: any): ProjectCreate {
  return ProjectCreateToJSONTyped(json, false);
}

export function ProjectCreateToJSONTyped(
  value?: ProjectCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    name: value["name"],
    location: PointToJSON(value["location"]),
    location_name: value["locationName"],
    description: value["description"],
    client_name: value["clientName"],
    apply_folder_template: value["applyFolderTemplate"],
  };
}
